import { Shimmer } from '@components';
import {
  Container,
  Content,
  Header,
  Heading,
  Spacing,
  Buttons,
  ButtonsGrid,
  HeaderBottom,
} from './OnboardingFile.styles';

const TableContentLoading = ({ tab }: { tab?: string }) => {
  return (
    <Content>
      <Spacing>
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4 }}
          primary="#f1f1f1"
          secondary={tab === 'identified' ? '#F5F7FB' : '#ececec'}
        />
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4, marginTop: 8 }}
          primary="#f1f1f1"
          secondary={tab === 'identified' ? '#F5F7FB' : '#ececec'}
        />
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4, marginTop: 8 }}
          primary="#f1f1f1"
          secondary={tab === 'identified' ? '#F5F7FB' : '#ececec'}
        />
      </Spacing>
    </Content>
  );
};

const TableLoading = () => {
  return (
    <>
      <Spacing>
        <Heading>
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <div />
        </Heading>
      </Spacing>

      <TableContentLoading />
    </>
  );
};

const OnboardingFileLoading = () => {
  return (
    <Container>
      <Header>
        <HeaderBottom>
          <Shimmer
            style={{ height: 36, width: 250, borderRadius: 8, marginRight: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Buttons>
            <Shimmer
              style={{
                height: 36,
                width: 250,
                borderRadius: 8,
                marginRight: 8,
              }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
            <Shimmer
              style={{ height: 36, width: 136, borderRadius: 8 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </Buttons>
        </HeaderBottom>
      </Header>

      <TableLoading />
    </Container>
  );
};

const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 18, width: 18, borderRadius: 4, marginLeft: 12 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

const AssetGroupingLoading = () => {
  return (
    <Container>
      <Header>
        <HeaderBottom>
          <ButtonsGrid>
            <Shimmer
              style={{
                height: 18,
                width: 204,
                borderRadius: 4,
                marginRight: 8,
              }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
            <Shimmer
              style={{
                height: 16,
                width: 350,
                borderRadius: 4,
                marginRight: 8,
                marginTop: 4,
              }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </ButtonsGrid>

          <Buttons>
            <Shimmer
              style={{
                height: 36,
                width: 250,
                borderRadius: 8,
                marginRight: 8,
              }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
            <Shimmer
              style={{ height: 36, width: 136, borderRadius: 8 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </Buttons>
        </HeaderBottom>
      </Header>

      <TableContentLoading />
    </Container>
  );
};

const FileNameLoading = () => {
  return (
    <Shimmer
      style={{ height: 16, width: 118, borderRadius: 4 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

export {
  OnboardingFileLoading,
  TableLoading,
  TableContentLoading,
  CountLoading,
  AssetGroupingLoading,
  FileNameLoading,
};
